import {Bindings} from "data/constants/bindings";
import type {
	IPinpointApiProvider,
	ISharePickPayload,
} from "data/providers/api/pinpoint.api.provider";
import {inject, injectable} from "inversify";
import {action, makeAutoObservable, observable, runInAction} from "mobx";

export interface IShareImage {
	link: string;
	preview: string;
}

const DEFAULT_SHARE_OBJECT: IShareImage = {
	link: "",
	preview: "",
};

export interface IShareStore {
	get isOpenShareModal(): boolean;
	get roundId(): number | null;
	get shareImagePath(): IShareImage;

	toggleShareModal(): void;
	openShareModal({roundId}: {roundId: number}): void;
	closeShareModal(): void;
	shareTeam(payload: ISharePickPayload): Promise<void>;
}

@injectable()
export class ShareStore implements IShareStore {
	@observable private _isOpenShareModal: boolean = false;
	@observable private _shareImagePath: IShareImage = DEFAULT_SHARE_OBJECT;
	@observable private _roundId: number | null = null;

	get isOpenShareModal() {
		return this._isOpenShareModal;
	}

	get roundId() {
		return this._roundId;
	}

	get shareImagePath() {
		return this._shareImagePath;
	}

	constructor(
		@inject(Bindings.PinpointApiProvider) private _pinpointApiProvider: IPinpointApiProvider
	) {
		makeAutoObservable(this);
	}

	@action toggleShareModal() {
		this._isOpenShareModal = !this._isOpenShareModal;
	}

	@action openShareModal({roundId}: {roundId: number}) {
		this._isOpenShareModal = true;
		this._roundId = roundId;
	}

	@action closeShareModal() {
		this._isOpenShareModal = false;
		this._roundId = null;
		this._shareImagePath = DEFAULT_SHARE_OBJECT;
	}

	@action
	async shareTeam(payload: ISharePickPayload) {
		try {
			const response = await this._pinpointApiProvider.share(payload);
			const data = response.data.success;
			runInAction(() => {
				this._shareImagePath = data;
			});
		} catch (err) {
			console.log(err);
		}
	}
}
